//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {

  'use strict';

  $(document).on('change', '[data-form="chapter-select"]', function (ev) {
    var $this = $(this);
    var url = $this.find(':selected').attr('data-url');
    window.location = url;
  });

  //- ------------------------------------------------
  //- Fullscreen
  //- ------------------------------------------------

  fullscreen('data-chapters', 'chapters__carousel');

})();
